/**
 * The Harbour — frontend enums, caps, and tab chrome.
 * Values must stay aligned with express_app/constants/harbour.js
 * (plus last-used / activity types from harbourLastUsed and HarbourCase).
 *
 * Tab: Harbour. Subtitle: Customer success management board.
 * URL: /admin/the-bridge?tab=harbour
 *
 * Newsletter reminder (locked): CS-facing strip only. Harbour does not
 * send mail, build a recipient list, or query the estate. Copy the brief;
 * send outside. A later ESP is a new product decision.
 */

export const HARBOUR_TAB_KEY = 'harbour'
export const HARBOUR_TAB_LABEL = 'Harbour'
export const HARBOUR_PAGE_TITLE = 'Harbour'
export const HARBOUR_PAGE_SUBTITLE = 'Customer success management board'
export const HARBOUR_INTRO_COPY =
  'This is the work queue for today — who to call, and what happens next. The full venue estate stays in Spartacus.'

export const HARBOUR_TODAY_TITLE = 'Today'
export const HARBOUR_TODAY_SUBTITLE =
  'Chef call list — overdue first, then due today'
export const HARBOUR_MY_WORK_TITLE = 'My work'
export const HARBOUR_NEEDS_YOU_REGION_TITLE = 'Needs you'
export const HARBOUR_EMPTY_TODAY_COPY = 'No calls due. Pick from Needs you.'
export const HARBOUR_EMPTY_WORK_COPY = 'Start work from Needs you.'
export const HARBOUR_EMPTY_NEEDS_YOU_COPY = 'Nobody in the top queue.'
export const HARBOUR_EMPTY_COLUMN_COPY = 'Nothing here'
export const HARBOUR_UNTITLED_VENUE_NAME = 'Untitled venue'
export const HARBOUR_SEARCH_MISS_COPY =
  'Not in the top queue. Open in Spartacus.'
export const HARBOUR_SEARCH_GAP_MISS_COPY =
  'Nobody in paid Harbour scope matches this gap.'
export const HARBOUR_SEARCH_MISS_ACTION = 'Open in Spartacus'
export const HARBOUR_COPY_WHATSAPP_ACTION = 'Copy WhatsApp opener'
export const HARBOUR_WHATSAPP_CHAT_ACTION = 'WhatsApp chat'
export const HARBOUR_COPY_LINK_ACTION = 'Copy link'
export const HARBOUR_COPY_EMAILS_ACTION = 'Copy emails'
export const HARBOUR_COPY_EMAILS_TOAST = 'Emails copied'
export const HARBOUR_OLLIE_SUGGEST_ACTION = 'Suggest next step'
export const HARBOUR_OLLIE_SUGGEST_BUSY = 'Suggesting…'
export const HARBOUR_OLLIE_SUGGEST_COPY_WHATSAPP = 'Copy for WhatsApp'
export const HARBOUR_OLLIE_SUGGEST_COPY_EMAIL = 'Copy for email'
export const HARBOUR_OLLIE_SUGGEST_COPY_LOG = 'Copy for log'
export const HARBOUR_OLLIE_SUGGEST_CAPTION =
  'Paste into WhatsApp, email, or the log. Harbour does not send.'
export const HARBOUR_OLLIE_SUGGEST_TOAST = 'Suggestion copied'
export const HARBOUR_OVERDUE_NUDGE_COPY =
  'overdue — do these before anything new.'
export const HARBOUR_CARD_LAST_USED_LIMIT = 8
export const HARBOUR_LOG_START_WORK_FIRST = 'Start work before logging'
export const HARBOUR_HANDOFF_START_WORK_FIRST =
  'Start work before asking sales or product'
export const HARBOUR_HANDOFF_SEND_LABEL = 'Send'
export const HARBOUR_HANDOFF_SENDING_LABEL = 'Sending…'
export const HARBOUR_HANDOFF_SEND_SALES_LABEL = 'Send to sales'
export const HARBOUR_HANDOFF_SEND_PRODUCT_LABEL = 'Send to product'
export const HARBOUR_LOG_SAVE_LABEL = 'Save'
export const HARBOUR_LOG_FOLLOW_UP_WAIT_COPY =
  'Choose Spoke or Follow-up needed first — the date fills itself.'
export const HARBOUR_LOG_FOLLOW_UP_CLOSED_COPY = 'Closed has no follow-up date.'
export const HARBOUR_LAST_LOG_TITLE = 'Last log'
export const HARBOUR_PARK_COPY =
  'Recovered is how you finish a client — they stay off the default board and KPIs until Start work. This is not a 7 / 14 / 30-day experiment. Quiet stats do not bring them back. Other reasons work the same.'
export const HARBOUR_PARK_CLOSED_HINT =
  'Park as Recovered to take them off the board until Start work. Closed only means this call has no follow-up.'
export const HARBOUR_CLOSED_LOG_COPY =
  'Closed means this call has no follow-up. Park as Recovered to take them off the board until Start work.'
export const HARBOUR_PARK_ACTION = 'Park'
export const HARBOUR_PARK_RECOVERED_ACTION = 'Park as Recovered'
export const HARBOUR_PARK_TOAST = 'Parked'
export const HARBOUR_PARK_RECOVERED_TOAST =
  'Parked as Recovered — off the board until Start work'
export const HARBOUR_NOTES_TITLE = 'Spartacus notes'
export const HARBOUR_NOTES_HINT =
  'Same notebook as Spartacus — pinned first, then recent.'
export const HARBOUR_NOTES_EMPTY = 'No customer notes yet for this venue'
export const HARBOUR_NOTES_PINNED = 'Pinned'
export const HARBOUR_NOTES_PIN_THIS = 'Pin this note'
export const HARBOUR_NOTES_PIN = 'Pin'
export const HARBOUR_NOTES_UNPIN = 'Unpin'
export const HARBOUR_NOTES_ADD = 'Add note'
export const HARBOUR_NOTES_PLACEHOLDER = 'Add a customer note for the team…'
export const HARBOUR_NOTES_ADDED = 'Note added in Spartacus'
export const HARBOUR_NOTES_ADDED_PINNED = 'Note added and pinned in Spartacus'
export const HARBOUR_NOTES_PINNED_TOAST = 'Note pinned in Spartacus'
export const HARBOUR_NOTES_UNPINNED_TOAST = 'Note unpinned'
export const HARBOUR_HOW_IT_WORKS_TITLE = 'How the Harbour works'
export const HARBOUR_HOW_IT_WORKS_LINK = 'How this board works'
export const HARBOUR_HOW_IT_WORKS_DISMISS = "Don't show again"
export const HARBOUR_PARKED_SAME_CARD_COPY =
  'Parked venues stay off Harbour until Start work (that unparks). Quiet stats do not bring them back. They do not get a second tile.'
export const HARBOUR_HOW_IT_WORKS_BRIEFING_COPY =
  'Open a card. The briefing sits in the centre — talking points, last used, and the log. Copy emails next to Call. Suggest next step copies for WhatsApp or the log — Harbour does not send.'
export const HARBOUR_HOW_IT_WORKS_NOTES_COPY =
  'Same notebook as Spartacus — pinned first, then recent. Read and add notes in the drawer — you do not leave Harbour to write them. A cap says how many more live in Spartacus.'
export const HARBOUR_HOW_IT_WORKS_LOGIN_COPY =
  'Last login is the venue owner on this site — not a group manager logging in elsewhere. Quiet owner is 30+ days. Last order is this venue, quiet after 14 days.'
export const HARBOUR_HOW_IT_WORKS_NEEDS_YOU_COPY = `${HARBOUR_EMPTY_NEEDS_YOU_COPY} Healthy paid never refill it. A Thriving chip only appears when unclaimed paid venues have fresh login, order, CS touch, and a complete stack. Missing recipes, Ordering without receipting, and No GP search paid venues across Harbour — not just the top 30. The iceberg caption splits quiet login/order from missing stack so you know why a named account is not in the top 30.`
export const HARBOUR_HOW_IT_WORKS_CALL_COPY =
  "Call uses tel: and your Mac's default app. WhatsApp Desktop voice is not guaranteed. Use WhatsApp chat (wa.me) for a chat — Harbour does not send."
export const HARBOUR_HOW_IT_WORKS_RECOVERED_COPY =
  'Park Recovered takes them off the default board and KPIs until Start work. That is how you finish a client — not a two-week experiment. Quiet login or orders do not bounce them back. Closed only means this call has no follow-up.'
export const HARBOUR_HOW_IT_WORKS_CS_STACK_COPY =
  'Free: suppliers → ordering → receipting teaser → sales. Paid: recon → recipes → stock/GP/Xero → keep. Cards show the next rung — that is the job.'
export const HARBOUR_HOW_IT_WORKS_PARKED_COPY =
  'Park Recovered to finish a client — off the board until Start work. Quiet stats do not bring them back. Same card when they return; no second tile. Closed only means this call has no follow-up.'
export const HARBOUR_HOW_IT_WORKS_NEWSLETTER_COPY =
  'The monthly strip is a CS reminder — Harbour does not send mail, build a recipient list, or query the estate.'
export const HARBOUR_HOW_IT_WORKS_STEPS = Object.freeze([
  {
    title: 'Today is the call list',
    body: 'Overdue first. Work those before hunting for something new.',
  },
  {
    title: 'The CS stack is the play',
    body: HARBOUR_HOW_IT_WORKS_CS_STACK_COPY,
  },
  {
    title: 'Last login is the venue owner',
    body: HARBOUR_HOW_IT_WORKS_LOGIN_COPY,
  },
  {
    title: 'Empty Needs you stays empty',
    body: HARBOUR_HOW_IT_WORKS_NEEDS_YOU_COPY,
  },
  {
    title: 'Call vs WhatsApp',
    body: HARBOUR_HOW_IT_WORKS_CALL_COPY,
  },
  {
    title: 'The briefing opens in the centre',
    body: HARBOUR_HOW_IT_WORKS_BRIEFING_COPY,
  },
  {
    title: 'Spartacus notes live here',
    body: HARBOUR_HOW_IT_WORKS_NOTES_COPY,
  },
  {
    title: 'Recovered and parked venues',
    body: HARBOUR_HOW_IT_WORKS_PARKED_COPY,
  },
  {
    title: 'The newsletter strip is a reminder',
    body: HARBOUR_HOW_IT_WORKS_NEWSLETTER_COPY,
  },
])

/**
 * Monthly CS newsletter reminder — locked as a reminder, not a send path.
 * Harbour does not send mail, build a recipient list, or query the estate.
 * Rotation is the UK calendar month, not a live iceberg count. Customer
 * copy sells benefits; the CS hook may say this covers the pile they
 * will never ring. Every brief ends with Kev.
 */
export const HARBOUR_NEWSLETTER_TOPIC = Object.freeze({
  RECIPES: 'recipes',
  RECEIPTING: 'receipting',
  GP: 'gp',
  ORDERING: 'ordering',
  KEV: 'kev',
})

export const HARBOUR_NEWSLETTER_TOPICS = Object.freeze([
  HARBOUR_NEWSLETTER_TOPIC.RECIPES,
  HARBOUR_NEWSLETTER_TOPIC.RECEIPTING,
  HARBOUR_NEWSLETTER_TOPIC.GP,
  HARBOUR_NEWSLETTER_TOPIC.ORDERING,
  HARBOUR_NEWSLETTER_TOPIC.KEV,
])

export const HARBOUR_NEWSLETTER_KEV_PS =
  "I'm Kev, head of customer success. Reply to this if anything is stuck — I read them."
export const HARBOUR_NEWSLETTER_COPY_ACTION = 'Copy brief'
export const HARBOUR_NEWSLETTER_SENT_ACTION = 'We sent this'
export const HARBOUR_NEWSLETTER_LATER_ACTION = 'Next month'
export const HARBOUR_NEWSLETTER_SKIP_ACTION = 'Skip this topic'
export const HARBOUR_NEWSLETTER_COPY_TOAST = 'Brief copied'
export const HARBOUR_NEWSLETTER_FOR_LABEL = 'For'

export const HARBOUR_NEWSLETTER_BRIEFS = Object.freeze({
  [HARBOUR_NEWSLETTER_TOPIC.RECIPES]: Object.freeze({
    id: HARBOUR_NEWSLETTER_TOPIC.RECIPES,
    title: 'Recipes',
    csHook:
      "This month's letter covers the pile you will never ring. Paid chefs already buying who still have no recipes.",
    audience: 'Paid venues missing recipes — the same stack gap as Needs you.',
    benefits: Object.freeze([
      'You already buy the food — recipes turn invoices into dish cost so you know what to charge.',
      'One costed dish means you stop guessing when a supplier puts the price up.',
      'New starters can cook the same plate without a WhatsApp to the head chef.',
    ]),
    kevPS: HARBOUR_NEWSLETTER_KEV_PS,
  }),
  [HARBOUR_NEWSLETTER_TOPIC.RECEIPTING]: Object.freeze({
    id: HARBOUR_NEWSLETTER_TOPIC.RECEIPTING,
    title: 'Receipting',
    csHook:
      "This month's letter covers the pile you will never ring. Anyone who orders without ticking goods in.",
    audience: 'Venues that order without ticking goods in.',
    benefits: Object.freeze([
      'Thirty seconds on the dock stops you paying for short deliveries.',
      'Invoice queries take minutes later if the tick is already in the system.',
      'Recipes and GP are fiction until what arrived matches what you ordered.',
    ]),
    kevPS: HARBOUR_NEWSLETTER_KEV_PS,
  }),
  [HARBOUR_NEWSLETTER_TOPIC.GP]: Object.freeze({
    id: HARBOUR_NEWSLETTER_TOPIC.GP,
    title: 'GP',
    csHook:
      "This month's letter covers the pile you will never ring. Paid sites that receipt and recipe but never look at GP.",
    audience: 'Paid venues that receipt and recipe but never look at GP.',
    benefits: Object.freeze([
      'GP is the scoreboard — you can finally see which dishes actually make money.',
      'Quiet killers (portion creep, waste) show up before the month-end panic.',
      'You are already paying for this view if you receipt and recipe.',
    ]),
    kevPS: HARBOUR_NEWSLETTER_KEV_PS,
  }),
  [HARBOUR_NEWSLETTER_TOPIC.ORDERING]: Object.freeze({
    id: HARBOUR_NEWSLETTER_TOPIC.ORDERING,
    title: 'Ordering',
    csHook:
      "This month's letter covers the pile you will never ring. Free venues still on five supplier portals.",
    audience: 'Free venues still ordering in supplier portals.',
    benefits: Object.freeze([
      'One list instead of five supplier logins — Tuesday afternoon back.',
      'The same basket every week means fewer forgotten lines and emergency shop runs.',
      'When you are ready to grow, receipting is one step from a list you already use.',
    ]),
    kevPS: HARBOUR_NEWSLETTER_KEV_PS,
  }),
  [HARBOUR_NEWSLETTER_TOPIC.KEV]: Object.freeze({
    id: HARBOUR_NEWSLETTER_TOPIC.KEV,
    title: 'Kev is here',
    csHook:
      "This month's letter is the excuse to write. Ask for a reply so they know Kev is there — especially people you will never call.",
    audience: 'Everyone — especially people we will never call.',
    benefits: Object.freeze([
      'Reply to this — a real person reads it, and you do not need a scheduled call first.',
      'Stuck on a screen? Ask. Kev is there for anything, not only the topic of the letter.',
      "Tell us what would make next month's letter useful; we write for you, not at you.",
    ]),
    kevPS: HARBOUR_NEWSLETTER_KEV_PS,
  }),
})

export const HARBOUR_TIMEZONE = 'Europe/London'
/** Deep-link a venue drawer (`?tab=harbour&venue=<id>`). Unassigned is lifted. */
export const HARBOUR_VENUE_QUERY = 'venue'
export const HARBOUR_SEARCH_DEBOUNCE_MS = 250
export const HARBOUR_SEARCH_MIN_CHARS = 1

export const HARBOUR_COLUMN = Object.freeze({
  NEEDS_YOU: 'needs_you',
  WORKING: 'working',
  WAITING: 'waiting',
  ASK_SALES: 'ask_sales',
  ASK_PRODUCT: 'ask_product',
  PARKED: 'parked',
})

export const HARBOUR_COLUMNS = Object.freeze([
  HARBOUR_COLUMN.NEEDS_YOU,
  HARBOUR_COLUMN.WORKING,
  HARBOUR_COLUMN.WAITING,
  HARBOUR_COLUMN.ASK_SALES,
  HARBOUR_COLUMN.ASK_PRODUCT,
  HARBOUR_COLUMN.PARKED,
])

/**
 * Column meta for the kanban. Accents are OMS greens / greys, not a sales rainbow.
 */
export const HARBOUR_COLUMN_META = Object.freeze({
  [HARBOUR_COLUMN.NEEDS_YOU]: {
    key: HARBOUR_COLUMN.NEEDS_YOU,
    label: 'Needs you',
    subtitle: 'Unclaimed top queue',
    order: 1,
    columnAccent: '#C45C26',
    columnBackground: '#FBF6F1',
  },
  [HARBOUR_COLUMN.WORKING]: {
    key: HARBOUR_COLUMN.WORKING,
    label: 'Working',
    subtitle: 'Claimed, we have a next step',
    order: 2,
    columnAccent: '#5B8A72',
    columnBackground: '#F4F8F6',
  },
  [HARBOUR_COLUMN.WAITING]: {
    key: HARBOUR_COLUMN.WAITING,
    label: 'Waiting',
    subtitle: 'Ball in their court',
    order: 3,
    columnAccent: '#6B7280',
    columnBackground: '#F6F7F8',
  },
  [HARBOUR_COLUMN.ASK_SALES]: {
    key: HARBOUR_COLUMN.ASK_SALES,
    label: 'Ask sales',
    subtitle: 'Upsell or commercial save',
    order: 4,
    columnAccent: '#3D6B8A',
    columnBackground: '#F3F7FA',
  },
  [HARBOUR_COLUMN.ASK_PRODUCT]: {
    key: HARBOUR_COLUMN.ASK_PRODUCT,
    label: 'Ask product',
    subtitle: 'Gap, bug, or unhappy with the product',
    order: 5,
    columnAccent: '#5A6B7D',
    columnBackground: '#F4F6F8',
  },
  [HARBOUR_COLUMN.PARKED]: {
    key: HARBOUR_COLUMN.PARKED,
    label: 'Parked',
    subtitle: 'Hidden from KPIs and default view',
    order: 6,
    columnAccent: '#8A8175',
    columnBackground: '#F7F5F2',
  },
})

export const HARBOUR_PARKED_COLUMNS = Object.freeze([HARBOUR_COLUMN.PARKED])

export const HARBOUR_OPEN_COLUMNS = Object.freeze(
  HARBOUR_COLUMNS.filter(column => !HARBOUR_PARKED_COLUMNS.includes(column)),
)

export const HARBOUR_WORK_COLUMNS = Object.freeze([
  HARBOUR_COLUMN.WORKING,
  HARBOUR_COLUMN.WAITING,
  HARBOUR_COLUMN.ASK_SALES,
  HARBOUR_COLUMN.ASK_PRODUCT,
])

export const HARBOUR_UNASSIGNED_COLUMNS = Object.freeze([
  HARBOUR_COLUMN.NEEDS_YOU,
])

export const HARBOUR_DEFAULT_COLUMN = HARBOUR_COLUMN.NEEDS_YOU

export const HARBOUR_HANDOFF_COLUMNS = Object.freeze([
  HARBOUR_COLUMN.ASK_SALES,
  HARBOUR_COLUMN.ASK_PRODUCT,
])

/** Stored columns shown on the board (Today is derived, not stored). */
export const HARBOUR_BOARD_VISIBLE_COLUMNS = Object.freeze([
  HARBOUR_COLUMN.NEEDS_YOU,
  ...HARBOUR_WORK_COLUMNS,
])

export const HARBOUR_BOARD_SECTION = Object.freeze({
  WORK: 'work',
  NEEDS_YOU: 'needs_you',
  ALL: 'all',
})

export const HARBOUR_BOARD_SECTIONS = Object.freeze([
  HARBOUR_BOARD_SECTION.WORK,
  HARBOUR_BOARD_SECTION.NEEDS_YOU,
  HARBOUR_BOARD_SECTION.ALL,
])

export const HARBOUR_PARK_REASON = Object.freeze({
  RECOVERED: 'recovered',
  SEASONAL: 'seasonal',
  SOLD: 'sold',
  DUPLICATE: 'duplicate',
  CLOSED: 'closed',
  HANDED_ON: 'handed_on',
})

export const HARBOUR_PARK_REASONS = Object.freeze([
  HARBOUR_PARK_REASON.RECOVERED,
  HARBOUR_PARK_REASON.SEASONAL,
  HARBOUR_PARK_REASON.SOLD,
  HARBOUR_PARK_REASON.DUPLICATE,
  HARBOUR_PARK_REASON.CLOSED,
  HARBOUR_PARK_REASON.HANDED_ON,
])

export const HARBOUR_PARK_REASON_META = Object.freeze({
  [HARBOUR_PARK_REASON.RECOVERED]: {
    key: HARBOUR_PARK_REASON.RECOVERED,
    label: 'Recovered',
  },
  [HARBOUR_PARK_REASON.SEASONAL]: {
    key: HARBOUR_PARK_REASON.SEASONAL,
    label: 'Seasonal / closed for winter',
  },
  [HARBOUR_PARK_REASON.SOLD]: {
    key: HARBOUR_PARK_REASON.SOLD,
    label: 'Sold',
  },
  [HARBOUR_PARK_REASON.DUPLICATE]: {
    key: HARBOUR_PARK_REASON.DUPLICATE,
    label: 'Duplicate',
  },
  [HARBOUR_PARK_REASON.CLOSED]: {
    key: HARBOUR_PARK_REASON.CLOSED,
    label: 'Venue closed',
  },
  [HARBOUR_PARK_REASON.HANDED_ON]: {
    key: HARBOUR_PARK_REASON.HANDED_ON,
    label: 'Handed on',
  },
})

export const HARBOUR_SNOOZE_DAYS = Object.freeze([7, 14, 30])
/** Parked (including Recovered) stays parked until Start work. Not a snooze. */
export const HARBOUR_PARK_UNTIL_START_WORK = true
export const HARBOUR_PARK_STATS_COOLOFF_DAYS = null

export const HARBOUR_OUTCOME = Object.freeze({
  NO_ANSWER: 'no_answer',
  SPOKE: 'spoke',
  FOLLOW_UP_NEEDED: 'follow_up_needed',
  CLOSED: 'closed',
})

export const HARBOUR_OUTCOMES = Object.freeze([
  HARBOUR_OUTCOME.NO_ANSWER,
  HARBOUR_OUTCOME.SPOKE,
  HARBOUR_OUTCOME.FOLLOW_UP_NEEDED,
  HARBOUR_OUTCOME.CLOSED,
])

export const HARBOUR_OUTCOME_META = Object.freeze({
  [HARBOUR_OUTCOME.NO_ANSWER]: {
    key: HARBOUR_OUTCOME.NO_ANSWER,
    label: 'No answer',
  },
  [HARBOUR_OUTCOME.SPOKE]: {
    key: HARBOUR_OUTCOME.SPOKE,
    label: 'Spoke',
  },
  [HARBOUR_OUTCOME.FOLLOW_UP_NEEDED]: {
    key: HARBOUR_OUTCOME.FOLLOW_UP_NEEDED,
    label: 'Follow-up needed',
  },
  [HARBOUR_OUTCOME.CLOSED]: {
    key: HARBOUR_OUTCOME.CLOSED,
    label: 'Closed',
  },
})

export const HARBOUR_OUTCOME_FOLLOW_UP_DAYS = Object.freeze({
  [HARBOUR_OUTCOME.NO_ANSWER]: 1,
  [HARBOUR_OUTCOME.SPOKE]: 3,
  [HARBOUR_OUTCOME.FOLLOW_UP_NEEDED]: 7,
  [HARBOUR_OUTCOME.CLOSED]: null,
})

export const HARBOUR_INTENT = Object.freeze({
  GET_ORDER: 'get_order',
  RECEIPTING: 'receipting',
  INVOICES: 'invoices',
  SAVE_PAID: 'save_paid',
  UPSELL: 'upsell',
})

export const HARBOUR_INTENTS = Object.freeze([
  HARBOUR_INTENT.GET_ORDER,
  HARBOUR_INTENT.RECEIPTING,
  HARBOUR_INTENT.INVOICES,
  HARBOUR_INTENT.SAVE_PAID,
  HARBOUR_INTENT.UPSELL,
])

export const HARBOUR_INTENT_META = Object.freeze({
  [HARBOUR_INTENT.GET_ORDER]: {
    key: HARBOUR_INTENT.GET_ORDER,
    label: 'Get them to place an order',
  },
  [HARBOUR_INTENT.RECEIPTING]: {
    key: HARBOUR_INTENT.RECEIPTING,
    label: 'Receipting',
  },
  [HARBOUR_INTENT.INVOICES]: {
    key: HARBOUR_INTENT.INVOICES,
    label: 'Invoices',
  },
  [HARBOUR_INTENT.SAVE_PAID]: {
    key: HARBOUR_INTENT.SAVE_PAID,
    label: 'Save paid',
  },
  [HARBOUR_INTENT.UPSELL]: {
    key: HARBOUR_INTENT.UPSELL,
    label: 'Upsell / Ask sales',
  },
})

export const HARBOUR_INBOUND_SOURCE = Object.freeze({
  LANDED: 'landed',
  CS_NEEDED: 'cs_needed',
  RISK: 'risk',
  UPGRADE: 'upgrade',
})

export const HARBOUR_INBOUND_SOURCES = Object.freeze([
  HARBOUR_INBOUND_SOURCE.LANDED,
  HARBOUR_INBOUND_SOURCE.CS_NEEDED,
  HARBOUR_INBOUND_SOURCE.RISK,
  HARBOUR_INBOUND_SOURCE.UPGRADE,
])

export const HARBOUR_INBOUND_SOURCE_META = Object.freeze({
  [HARBOUR_INBOUND_SOURCE.LANDED]: {
    key: HARBOUR_INBOUND_SOURCE.LANDED,
    label: 'Catch Board landed',
  },
  [HARBOUR_INBOUND_SOURCE.CS_NEEDED]: {
    key: HARBOUR_INBOUND_SOURCE.CS_NEEDED,
    label: 'Catch Board CS needed',
  },
  [HARBOUR_INBOUND_SOURCE.RISK]: {
    key: HARBOUR_INBOUND_SOURCE.RISK,
    label: 'At risk',
  },
  [HARBOUR_INBOUND_SOURCE.UPGRADE]: {
    key: HARBOUR_INBOUND_SOURCE.UPGRADE,
    label: 'Upgrade / Ask sales signal',
  },
})

export const HARBOUR_LIFECYCLE = Object.freeze({
  ONBOARD: 'onboard',
  ADOPTING: 'adopting',
  HEALTHY: 'healthy',
  AT_RISK: 'at_risk',
  CHURNING: 'churning',
})

export const HARBOUR_LIFECYCLES = Object.freeze([
  HARBOUR_LIFECYCLE.ONBOARD,
  HARBOUR_LIFECYCLE.ADOPTING,
  HARBOUR_LIFECYCLE.HEALTHY,
  HARBOUR_LIFECYCLE.AT_RISK,
  HARBOUR_LIFECYCLE.CHURNING,
])

export const HARBOUR_LIFECYCLE_META = Object.freeze({
  [HARBOUR_LIFECYCLE.ONBOARD]: {
    key: HARBOUR_LIFECYCLE.ONBOARD,
    label: 'Onboard',
  },
  [HARBOUR_LIFECYCLE.ADOPTING]: {
    key: HARBOUR_LIFECYCLE.ADOPTING,
    label: 'Adopting',
  },
  [HARBOUR_LIFECYCLE.HEALTHY]: {
    key: HARBOUR_LIFECYCLE.HEALTHY,
    label: 'Healthy',
  },
  [HARBOUR_LIFECYCLE.AT_RISK]: {
    key: HARBOUR_LIFECYCLE.AT_RISK,
    label: 'At risk',
  },
  [HARBOUR_LIFECYCLE.CHURNING]: {
    key: HARBOUR_LIFECYCLE.CHURNING,
    label: 'Churning',
  },
})

export const HARBOUR_OWNER_FILTER = Object.freeze({
  MINE: 'mine',
  ALL: 'all',
  UNASSIGNED: 'unassigned',
})

export const HARBOUR_OWNER_FILTERS = Object.freeze([
  HARBOUR_OWNER_FILTER.MINE,
  HARBOUR_OWNER_FILTER.ALL,
  HARBOUR_OWNER_FILTER.UNASSIGNED,
])

export const HARBOUR_OWNER_FILTER_META = Object.freeze({
  [HARBOUR_OWNER_FILTER.MINE]: {
    key: HARBOUR_OWNER_FILTER.MINE,
    label: 'My work',
  },
  [HARBOUR_OWNER_FILTER.ALL]: {
    key: HARBOUR_OWNER_FILTER.ALL,
    label: 'All',
  },
  [HARBOUR_OWNER_FILTER.UNASSIGNED]: {
    key: HARBOUR_OWNER_FILTER.UNASSIGNED,
    label: 'Unassigned',
  },
})

export const HARBOUR_DEFAULT_OWNER_FILTER = HARBOUR_OWNER_FILTER.MINE

export const HARBOUR_PLAN_FILTER = Object.freeze({
  ALL: 'all',
  PAID: 'paid',
  FREE: 'free',
})

export const HARBOUR_PLAN_FILTERS = Object.freeze([
  HARBOUR_PLAN_FILTER.ALL,
  HARBOUR_PLAN_FILTER.PAID,
  HARBOUR_PLAN_FILTER.FREE,
])

export const HARBOUR_PLAN_FILTER_META = Object.freeze({
  [HARBOUR_PLAN_FILTER.ALL]: {
    key: HARBOUR_PLAN_FILTER.ALL,
    label: 'All plans',
  },
  [HARBOUR_PLAN_FILTER.PAID]: { key: HARBOUR_PLAN_FILTER.PAID, label: 'Paid' },
  [HARBOUR_PLAN_FILTER.FREE]: { key: HARBOUR_PLAN_FILTER.FREE, label: 'Free' },
})

export const HARBOUR_DEFAULT_PLAN_FILTER = HARBOUR_PLAN_FILTER.ALL
export const HARBOUR_DEFAULT_HIDE_PARKED = true
export const HARBOUR_DEFAULT_HAS_PHONE = false
/** Off: Needs you stays the at-risk pile. On: opt-in Thriving cards. Never sticky. */
export const HARBOUR_DEFAULT_THRIVING = false

export const DEFAULT_HARBOUR_FILTERS = Object.freeze({
  ownerFilter: HARBOUR_DEFAULT_OWNER_FILTER,
  planFilter: HARBOUR_DEFAULT_PLAN_FILTER,
  hideParked: HARBOUR_DEFAULT_HIDE_PARKED,
  hasPhone: HARBOUR_DEFAULT_HAS_PHONE,
  search: '',
})
export const HARBOUR_NO_PHONE_COPY = 'No phone'
export const HARBOUR_THRIVING_LABEL = 'Thriving'
export const HARBOUR_THRIVING_CAPTION = 'Validate happiness or introduce sales.'
export const HARBOUR_ASK_SALES_WARMED_LABEL = 'Ask sales'
export const HARBOUR_ASK_SALES_WARMED_CAPTION =
  'Free · 5+ suppliers and ordering — hand off to sales.'

export const HARBOUR_FREE_SCOPE_ORDERED_WITHIN_DAYS = 90
/** Needs you shows at most 30 cards. Same-owner / brand stack-gap groups share one. */
export const HARBOUR_NEEDS_YOU_CAP = 30
export const HARBOUR_BOARD_PAYLOAD_MAX = 75
export const HARBOUR_SEARCH_LIMIT = 20
export const HARBOUR_DRAWER_NOTES_PAGE_SIZE = 20
export const HARBOUR_DRAWER_LINKED_DEALS_LIMIT = 20
export const HARBOUR_FORGOTTEN_AFTER_DAYS = 7
export const HARBOUR_QUIET_LOGIN_DAYS = 30
export const HARBOUR_QUIET_ORDER_DAYS = 14
export const HARBOUR_PAID_CHECK_IN_DAYS = 21
export const HARBOUR_STALL_MIN_CS_TOUCHES = 2
export const HARBOUR_HANDOFF_NOTE_MAX_LENGTH = 1000
export const HARBOUR_OUTCOME_NOTE_MAX_LENGTH = 1000
/** Play + same-owner sites + CS facts (suppliers, recon, premium), then stop. */
export const HARBOUR_MAX_TALKING_POINTS = 5
export const HARBOUR_SISTER_TALKING_LIVE_HINT = 'check Spartacus for a live one'

export const HARBOUR_PERFORMANCE_CONTRACT = Object.freeze({
  spartacusVenueListForbidden: true,
  lastUsedRequiresVenueIds: true,
  pulseIsCountsOnly: true,
  dateRangeBoardForbidden: true,
  needsYouCapIsProduct: true,
  maxHydrateIds: HARBOUR_BOARD_PAYLOAD_MAX,
  needsYouCap: HARBOUR_NEEDS_YOU_CAP,
  searchLimit: HARBOUR_SEARCH_LIMIT,
})

export const HARBOUR_BOARD_FORBIDDEN_QUERY_KEYS = Object.freeze([
  'fromDate',
  'toDate',
  'priorFromDate',
  'priorToDate',
  'dateFrom',
  'dateTo',
  'startDate',
  'endDate',
])

export const HARBOUR_PULSE_FORBIDDEN_KEYS = Object.freeze([
  'venues',
  'cards',
  'deals',
  'rows',
  'items',
])

export const HARBOUR_ERROR_CODE = Object.freeze({
  FORBIDDEN: 'HARBOUR_FORBIDDEN',
  VALIDATION: 'HARBOUR_VALIDATION_ERROR',
  ALREADY_TAKEN: 'HARBOUR_ALREADY_TAKEN',
  NOT_FOUND: 'HARBOUR_NOT_FOUND',
})

export const HARBOUR_PERFORMANCE_ERROR_CODE = 'HARBOUR_PERFORMANCE_ERROR'

export const HARBOUR_LOG_NOTE_TYPES = Object.freeze([
  'Call',
  'Email',
  'WhatsApp',
  'Internal',
])

export const HARBOUR_DEFAULT_LOG_NOTE_TYPE = 'Call'

export const HARBOUR_ACTIVITY_TYPE = Object.freeze({
  CASE_CREATED: 'case_created',
  CLAIMED: 'claimed',
  OWNER_CHANGED: 'owner_changed',
  COLUMN_CHANGED: 'column_changed',
  OUTCOME_LOGGED: 'outcome_logged',
  SNOOZED: 'snoozed',
  SNOOZE_UNDONE: 'snooze_undone',
  PARKED: 'parked',
  PARK_UNDONE: 'park_undone',
  HANDED_OFF: 'handed_off',
  FOLLOW_UP_SET: 'follow_up_set',
  NOTE_ADDED: 'note_added',
})

export const HARBOUR_ACTIVITY_TYPES = Object.freeze(
  Object.values(HARBOUR_ACTIVITY_TYPE),
)

export const HARBOUR_LAST_USED_STATUS = Object.freeze({
  DATE: 'date',
  NEVER: 'never',
  UNKNOWN: 'unknown',
  ON: 'on',
})

export const HARBOUR_LAST_USED_TONE = Object.freeze({
  FRESH: 'fresh',
  QUIET: 'quiet',
  NEVER: 'never',
  UNKNOWN: 'unknown',
})

export const HARBOUR_LAST_USED_FEATURE = Object.freeze({
  LOGIN: 'lastLogin',
  ORDER: 'lastOrder',
  GOODS_RECEIPTING: 'lastGoodsReceipting',
  RECIPE: 'lastRecipe',
  INVOICE: 'lastInvoice',
  STOCK_TAKE: 'lastStockTake',
  PAR_LEVEL: 'lastParLevel',
  GP: 'lastGp',
  PRICE_LIST: 'lastPriceList',
  XERO: 'lastXero',
  SPECIAL_PURCHASE: 'lastSpecialPurchase',
  RESTRICTED: 'lastRestrictedSupplier',
})

export const HARBOUR_LAST_USED_FEATURES = Object.freeze(
  Object.values(HARBOUR_LAST_USED_FEATURE),
)

export const HARBOUR_LAST_USED_FEATURE_META = Object.freeze({
  [HARBOUR_LAST_USED_FEATURE.LOGIN]: {
    key: HARBOUR_LAST_USED_FEATURE.LOGIN,
    label: 'Owner last seen',
  },
  [HARBOUR_LAST_USED_FEATURE.ORDER]: {
    key: HARBOUR_LAST_USED_FEATURE.ORDER,
    label: 'Orders',
  },
  [HARBOUR_LAST_USED_FEATURE.GOODS_RECEIPTING]: {
    key: HARBOUR_LAST_USED_FEATURE.GOODS_RECEIPTING,
    label: 'Receipting',
  },
  [HARBOUR_LAST_USED_FEATURE.RECIPE]: {
    key: HARBOUR_LAST_USED_FEATURE.RECIPE,
    label: 'Recipes',
  },
  [HARBOUR_LAST_USED_FEATURE.INVOICE]: {
    key: HARBOUR_LAST_USED_FEATURE.INVOICE,
    label: 'Invoices',
  },
  [HARBOUR_LAST_USED_FEATURE.STOCK_TAKE]: {
    key: HARBOUR_LAST_USED_FEATURE.STOCK_TAKE,
    label: 'Stock takes',
  },
  [HARBOUR_LAST_USED_FEATURE.PAR_LEVEL]: {
    key: HARBOUR_LAST_USED_FEATURE.PAR_LEVEL,
    label: 'Par levels',
  },
  [HARBOUR_LAST_USED_FEATURE.GP]: {
    key: HARBOUR_LAST_USED_FEATURE.GP,
    label: 'GP',
  },
  [HARBOUR_LAST_USED_FEATURE.PRICE_LIST]: {
    key: HARBOUR_LAST_USED_FEATURE.PRICE_LIST,
    label: 'Price lists',
  },
  [HARBOUR_LAST_USED_FEATURE.XERO]: {
    key: HARBOUR_LAST_USED_FEATURE.XERO,
    label: 'Xero',
  },
  [HARBOUR_LAST_USED_FEATURE.SPECIAL_PURCHASE]: {
    key: HARBOUR_LAST_USED_FEATURE.SPECIAL_PURCHASE,
    label: 'Special purchases',
  },
  [HARBOUR_LAST_USED_FEATURE.RESTRICTED]: {
    key: HARBOUR_LAST_USED_FEATURE.RESTRICTED,
    label: 'Restricted',
  },
})

export const HARBOUR_CARD_RADAR_FEATURES = Object.freeze([
  HARBOUR_LAST_USED_FEATURE.LOGIN,
  HARBOUR_LAST_USED_FEATURE.ORDER,
])

/** Adoption ladder on the card. Login and orders sit on the radar row instead. */
export const HARBOUR_ADOPTION_LADDER_TIER = Object.freeze({
  CRITICAL: 'critical',
  SECONDARY: 'secondary',
})

export const HARBOUR_ADOPTION_TICKS = Object.freeze([
  {
    key: 'receipting',
    label: 'Receipting',
    feature: HARBOUR_LAST_USED_FEATURE.GOODS_RECEIPTING,
    tier: HARBOUR_ADOPTION_LADDER_TIER.CRITICAL,
  },
  {
    key: 'recipes',
    label: 'Recipes',
    feature: HARBOUR_LAST_USED_FEATURE.RECIPE,
    tier: HARBOUR_ADOPTION_LADDER_TIER.CRITICAL,
  },
  {
    key: 'gp',
    label: 'GP',
    feature: HARBOUR_LAST_USED_FEATURE.GP,
    tier: HARBOUR_ADOPTION_LADDER_TIER.CRITICAL,
  },
  {
    key: 'invoices',
    label: 'Invoices',
    feature: HARBOUR_LAST_USED_FEATURE.INVOICE,
    tier: HARBOUR_ADOPTION_LADDER_TIER.SECONDARY,
  },
  {
    key: 'stock',
    label: 'Stock takes',
    feature: HARBOUR_LAST_USED_FEATURE.STOCK_TAKE,
    tier: HARBOUR_ADOPTION_LADDER_TIER.SECONDARY,
  },
  {
    key: 'xero',
    label: 'Xero',
    feature: HARBOUR_LAST_USED_FEATURE.XERO,
    tier: HARBOUR_ADOPTION_LADDER_TIER.SECONDARY,
  },
  {
    key: 'special_purchases',
    label: 'Special purchases',
    feature: HARBOUR_LAST_USED_FEATURE.SPECIAL_PURCHASE,
    tier: HARBOUR_ADOPTION_LADDER_TIER.SECONDARY,
  },
  {
    key: 'restricted',
    label: 'Restricted',
    feature: HARBOUR_LAST_USED_FEATURE.RESTRICTED,
    tier: HARBOUR_ADOPTION_LADDER_TIER.SECONDARY,
  },
])

/** Paid under-adoption search facets. Same keys as sister-group stack gaps. */
export const HARBOUR_ADOPTION_GAP = Object.freeze({
  RECIPES: 'recipes',
  RECEIPTING: 'receipting',
  GP: 'gp',
})

export const HARBOUR_ADOPTION_GAPS = Object.freeze([
  HARBOUR_ADOPTION_GAP.RECIPES,
  HARBOUR_ADOPTION_GAP.RECEIPTING,
  HARBOUR_ADOPTION_GAP.GP,
])

export const HARBOUR_ADOPTION_GAP_META = Object.freeze({
  [HARBOUR_ADOPTION_GAP.RECIPES]: {
    key: HARBOUR_ADOPTION_GAP.RECIPES,
    label: 'Missing recipes',
  },
  [HARBOUR_ADOPTION_GAP.RECEIPTING]: {
    key: HARBOUR_ADOPTION_GAP.RECEIPTING,
    label: 'Ordering without receipting',
  },
  [HARBOUR_ADOPTION_GAP.GP]: {
    key: HARBOUR_ADOPTION_GAP.GP,
    label: 'No GP',
  },
})

export function isHarbourAdoptionGap(value) {
  return HARBOUR_ADOPTION_GAPS.includes(value)
}

export function isHarbourNewsletterTopic(value) {
  return HARBOUR_NEWSLETTER_TOPICS.includes(value)
}

/**
 * UK calendar month `YYYY-MM`. Invalid keys return null.
 * @param {string|null|undefined} cycleKey
 * @returns {{ year: number, month: number }|null}
 */
export function parseHarbourNewsletterCycleKey(cycleKey) {
  const match = String(cycleKey || '')
    .trim()
    .match(/^(\d{4})-(\d{2})$/)
  if (!match) {
    return null
  }
  const year = Number(match[1])
  const month = Number(match[2])
  if (!Number.isFinite(year) || month < 1 || month > 12) {
    return null
  }
  return { year, month }
}

/**
 * Next UK calendar month after `cycleKey` (`2026-12` → `2027-01`).
 * Invalid keys return null.
 * @param {string|null|undefined} cycleKey
 */
export function getHarbourNewsletterNextCycleKey(cycleKey) {
  const parsed = parseHarbourNewsletterCycleKey(cycleKey)
  if (!parsed) {
    return null
  }
  const month = parsed.month === 12 ? 1 : parsed.month + 1
  const year = parsed.month === 12 ? parsed.year + 1 : parsed.year
  return `${year}-${String(month).padStart(2, '0')}`
}

export const HARBOUR_NEWSLETTER_ACTION = Object.freeze({
  SENT: 'sent',
  LATER: 'later',
  SKIP: 'skip',
})

export const HARBOUR_NEWSLETTER_ACTIONS = Object.freeze(
  Object.values(HARBOUR_NEWSLETTER_ACTION),
)

export function isHarbourNewsletterAction(value) {
  return HARBOUR_NEWSLETTER_ACTIONS.includes(value)
}

/**
 * January = recipes, February = receipting, … May = Kev, then it wraps.
 * `skipOffset` walks forward for the rest of this UK month only.
 * Invalid cycle keys fall back to recipes so a banner always has a brief.
 * @param {string|null|undefined} cycleKey
 * @param {number} [skipOffset]
 */
export function getHarbourNewsletterTopicIdForCycle(cycleKey, skipOffset = 0) {
  const count = HARBOUR_NEWSLETTER_TOPICS.length
  const parsed = parseHarbourNewsletterCycleKey(cycleKey)
  const monthIndex = parsed ? parsed.month - 1 : 0
  const offset = Number.isFinite(Number(skipOffset))
    ? Math.max(0, Math.floor(Number(skipOffset)))
    : 0
  const index = (monthIndex + offset) % count
  return HARBOUR_NEWSLETTER_TOPICS[index]
}

/**
 * @param {string|null|undefined} topicId
 * @returns {object|null}
 */
export function getHarbourNewsletterBrief(topicId) {
  if (!isHarbourNewsletterTopic(topicId)) {
    return null
  }
  return HARBOUR_NEWSLETTER_BRIEFS[topicId] || null
}

/**
 * @param {string|null|undefined} cycleKey
 * @param {number} [skipOffset]
 */
export function getHarbourNewsletterBriefForCycle(cycleKey, skipOffset = 0) {
  return getHarbourNewsletterBrief(
    getHarbourNewsletterTopicIdForCycle(cycleKey, skipOffset),
  )
}

/**
 * Paste-ready customer brief. CS hook stays on the strip, not in the paste.
 * @param {object} [brief]
 */
export function formatHarbourNewsletterBriefClipboard(brief = {}) {
  const audience = String(brief?.audience || '').trim()
  const benefits = (Array.isArray(brief?.benefits) ? brief.benefits : [])
    .map(line => String(line || '').trim())
    .filter(Boolean)
  const kevPS = String(brief?.kevPS || HARBOUR_NEWSLETTER_KEV_PS).trim()
  const parts = []
  if (audience) {
    parts.push(audience)
  }
  if (benefits.length) {
    parts.push(benefits.map(line => `• ${line}`).join('\n'))
  }
  if (kevPS) {
    parts.push(kevPS)
  }
  return parts.join('\n\n')
}

export const HARBOUR_UNCLAIMED_OWNER_LABEL = 'Unclaimed'
export const HARBOUR_ALREADY_YOURS_COPY = "You're already on this venue"

export function isHarbourColumn(value) {
  return HARBOUR_COLUMNS.includes(value)
}

export function isHarbourParkedColumn(value) {
  return HARBOUR_PARKED_COLUMNS.includes(value)
}

export function isHarbourOpenColumn(value) {
  return HARBOUR_OPEN_COLUMNS.includes(value)
}

export function isHarbourWorkColumn(value) {
  return HARBOUR_WORK_COLUMNS.includes(value)
}

export function isHarbourHandoffColumn(value) {
  return HARBOUR_HANDOFF_COLUMNS.includes(value)
}

export function isHarbourParkReason(value) {
  return HARBOUR_PARK_REASONS.includes(value)
}

export function isHarbourOutcome(value) {
  return HARBOUR_OUTCOMES.includes(value)
}

export function isHarbourIntent(value) {
  return HARBOUR_INTENTS.includes(value)
}

export function isHarbourInboundSource(value) {
  return HARBOUR_INBOUND_SOURCES.includes(value)
}

export function isHarbourLifecycle(value) {
  return HARBOUR_LIFECYCLES.includes(value)
}

export function isHarbourOwnerFilter(value) {
  return HARBOUR_OWNER_FILTERS.includes(value)
}

export function isHarbourPlanFilter(value) {
  return HARBOUR_PLAN_FILTERS.includes(value)
}

export function isHarbourSnoozeDays(value) {
  return HARBOUR_SNOOZE_DAYS.includes(Number(value))
}

export function isHarbourBoardSection(value) {
  return HARBOUR_BOARD_SECTIONS.includes(value)
}

/** Empty / Untitled — hide from Needs you, keep in name search. */
export function isHarbourNamelessVenueName(name) {
  const title = String(name || '').trim()
  if (!title) {
    return true
  }
  const lower = title.toLowerCase()
  return (
    lower === HARBOUR_UNTITLED_VENUE_NAME.toLowerCase() ||
    lower === 'a business with no name'
  )
}

/**
 * OMS / (Test) / staging internals — hide from Needs you, keep in name
 * search. Do not match a real chef title that merely contains “test”
 * (The Test Kitchen).
 */
export function isHarbourInternalVenueName(name) {
  const title = String(name || '').trim()
  if (!title) {
    return false
  }
  const lower = title.toLowerCase()
  return (
    /\(\s*test\s*\)/.test(lower) ||
    /\boms\b/.test(lower) ||
    /^test\s+venue\b/.test(lower) ||
    /\bstaging\b/.test(lower) ||
    /\btesting\b/.test(lower) ||
    /\btest(?:\s*[-–]?\s*\d+)?\s*$/.test(lower)
  )
}

export function getHarbourVenueDisplayName(name) {
  const title = String(name || '').trim()
  return isHarbourNamelessVenueName(title) ? HARBOUR_UNTITLED_VENUE_NAME : title
}

/**
 * Spartacus hunts by venue title (or email). Untitled names match too many
 * rows, so the id is the fallback — better than an empty search.
 */
export function getHarbourSpartacusHandoffQuery({ venueName, venueId } = {}) {
  const name = String(venueName || '').trim()
  if (name && !isHarbourNamelessVenueName(name)) {
    return name
  }
  return String(venueId || '').trim()
}

export function getHarbourColumnMeta(column) {
  return HARBOUR_COLUMN_META[column] || null
}

export function getHarbourColumnLabel(column) {
  return HARBOUR_COLUMN_META[column]?.label || column || ''
}

export function getHarbourParkReasonLabel(reason) {
  return HARBOUR_PARK_REASON_META[reason]?.label || reason || ''
}

export function getHarbourOutcomeLabel(outcome) {
  return HARBOUR_OUTCOME_META[outcome]?.label || outcome || ''
}

export function getHarbourIntentLabel(intent) {
  return HARBOUR_INTENT_META[intent]?.label || intent || ''
}

export function getHarbourInboundSourceLabel(source) {
  return HARBOUR_INBOUND_SOURCE_META[source]?.label || source || ''
}

export function getHarbourOwnerFilterLabel(filter) {
  return HARBOUR_OWNER_FILTER_META[filter]?.label || filter || ''
}

export function getHarbourPlanFilterLabel(filter) {
  return HARBOUR_PLAN_FILTER_META[filter]?.label || filter || ''
}

export function getHarbourLifecycleLabel(lifecycle) {
  return HARBOUR_LIFECYCLE_META[lifecycle]?.label || lifecycle || ''
}

export function getHarbourLastUsedFeatureLabel(feature) {
  return HARBOUR_LAST_USED_FEATURE_META[feature]?.label || feature || ''
}

export function getHarbourLastUsedQuietDays(feature) {
  if (feature === HARBOUR_LAST_USED_FEATURE.ORDER) {
    return HARBOUR_QUIET_ORDER_DAYS
  }
  return HARBOUR_QUIET_LOGIN_DAYS
}

export function formatHarbourOverdueBanner(count) {
  const overdue = Number(count) || 0
  if (overdue <= 0) {
    return null
  }
  return `${overdue} ${HARBOUR_OVERDUE_NUDGE_COPY}`
}

export function handoffRequiresNote(column) {
  return isHarbourHandoffColumn(column)
}

export function parkRequiresReason(reason) {
  return isHarbourParkReason(reason)
}

export function getHarbourFollowUpDaysForOutcome(outcome) {
  if (!isHarbourOutcome(outcome)) {
    return null
  }
  const days = HARBOUR_OUTCOME_FOLLOW_UP_DAYS[outcome]
  return days == null ? null : days
}

/**
 * POST /reassign has no lead / Kev role gate, so the steal control stays
 * hidden until the API can lock it to leads.
 */
export function canHarbourReassign() {
  return false
}

export function shouldShowHarbourNeedsYouIceberg({ shown, total } = {}) {
  const cap = Number(shown)
  const iceberg = Number(total)
  if (!Number.isFinite(cap) || !Number.isFinite(iceberg)) {
    return false
  }
  return iceberg > cap && cap >= 0
}

export function formatHarbourNeedsYouCaption({ shown, total } = {}) {
  if (!shouldShowHarbourNeedsYouIceberg({ shown, total })) {
    return null
  }
  return `${Number(total)} at-risk, showing ${Number(shown)}`
}

function toHarbourGapCount(value) {
  const n = Math.floor(Number(value) || 0)
  return n > 0 ? n : 0
}

/**
 * Optional sub-caption: quiet login/order vs missing stack vs free/inbound.
 */
export function formatHarbourNeedsYouCaptionDetail({
  loginGap = 0,
  adoptionGap = 0,
  other = 0,
} = {}) {
  const login = toHarbourGapCount(loginGap)
  const adoption = toHarbourGapCount(adoptionGap)
  const rest = toHarbourGapCount(other)
  const parts = []
  if (login) {
    parts.push(`${login} quiet login/order`)
  }
  if (adoption) {
    parts.push(`${adoption} missing stack`)
  }
  if (rest) {
    parts.push(`${rest} free / inbound`)
  }
  return parts.length ? parts.join(' · ') : null
}

export function formatHarbourThrivingChip(total) {
  const count = Math.max(0, Number(total) || 0)
  return `${HARBOUR_THRIVING_LABEL} (${count})`
}

export function formatHarbourAskSalesWarmedChip(total) {
  const count = Math.max(0, Number(total) || 0)
  return `${HARBOUR_ASK_SALES_WARMED_LABEL} (${count})`
}

/**
 * Talking-point copy from sisterVenueCount already on the card.
 * Does not fetch estate venues.
 */
export function formatHarbourSisterTalkingPoint(count) {
  const siteCount = Math.max(0, Number(count) || 0)
  if (siteCount < 1) {
    return null
  }
  const noun = siteCount === 1 ? 'other site' : 'other sites'
  return `+${siteCount} ${noun} (same owner) — ${HARBOUR_SISTER_TALKING_LIVE_HINT}`
}

/** Inboxes that are not a brand. Do not cluster gmail.com (etc.) as sisters. */
export const HARBOUR_PUBLIC_EMAIL_DOMAINS = Object.freeze([
  'gmail.com',
  'googlemail.com',
  'hotmail.com',
  'hotmail.co.uk',
  'outlook.com',
  'outlook.co.uk',
  'live.com',
  'msn.com',
  'yahoo.com',
  'yahoo.co.uk',
  'icloud.com',
  'me.com',
  'mac.com',
  'aol.com',
  'protonmail.com',
  'proton.me',
  'btinternet.com',
  'sky.com',
  'ordersmadesimple.com',
  'oms.com',
])

/** Title-prefix brand clusters need a brand token, not “The” / “Royal” / “Filler”. */
export const HARBOUR_BRAND_TITLE_PREFIX_MIN = 6

const HARBOUR_GENERIC_TITLE_TOKEN_SET = new Set([
  'the',
  'a',
  'an',
  'and',
  'royal',
  'kitchen',
  'kitchens',
  'bar',
  'cafe',
  'café',
  'hotel',
  'house',
  'restaurant',
  'restaurants',
  'inn',
  'pub',
  'grill',
  'diner',
  'lounge',
  'club',
  'food',
  'foods',
  'catering',
  'venue',
  'venues',
  'test',
  'testing',
  'staging',
  'filler',
  'other',
  'untitled',
  'business',
  'company',
  'ltd',
  'limited',
  'site',
  'sites',
  'shop',
  'shops',
])

function endsOnHarbourTitleTokenBoundary(prefix, title) {
  const stem = String(prefix || '')
  const text = String(title || '')
  if (!stem || !text.toLowerCase().startsWith(stem.toLowerCase())) {
    return false
  }
  if (text.length === stem.length) {
    return true
  }
  return /[\s\-–—,:/&]/.test(text[stem.length])
}

function trimHarbourTitlePrefixToToken(prefix, titles) {
  let stem = String(prefix || '')
    .replace(/[\s\-–—,:/&]+$/g, '')
    .trim()
  if (!stem) {
    return ''
  }
  const list = Array.isArray(titles) ? titles : []
  if (list.every(title => endsOnHarbourTitleTokenBoundary(stem, title))) {
    return stem
  }
  const cut = Math.max(
    stem.lastIndexOf(' '),
    stem.lastIndexOf('-'),
    stem.lastIndexOf('/'),
  )
  if (cut <= 0) {
    return ''
  }
  return trimHarbourTitlePrefixToToken(stem.slice(0, cut), titles)
}

export function isHarbourBrandTitlePrefix(prefix) {
  const stem = String(prefix || '').trim()
  if (stem.length < HARBOUR_BRAND_TITLE_PREFIX_MIN) {
    return false
  }
  if (/\d/.test(stem)) {
    return false
  }
  const tokens = stem
    .toLowerCase()
    .split(/[\s\-–—,:/&]+/)
    .filter(Boolean)
  if (tokens.length === 0) {
    return false
  }
  return tokens.some(token => !HARBOUR_GENERIC_TITLE_TOKEN_SET.has(token))
}

export const HARBOUR_SISTER_GROUP_GAP = Object.freeze({
  RECEIPTING: 'receipting',
  RECIPES: 'recipes',
  GP: 'gp',
})

export const HARBOUR_SISTER_GROUP_GAP_LABEL = Object.freeze({
  [HARBOUR_SISTER_GROUP_GAP.RECEIPTING]: 'receipting',
  [HARBOUR_SISTER_GROUP_GAP.RECIPES]: 'recipes',
  [HARBOUR_SISTER_GROUP_GAP.GP]: 'GP',
})

/** Shared brand token across sister titles, e.g. Mimi's Edinburgh / Glasgow. */
export function formatHarbourSisterGroupName(titles = []) {
  const cleaned = (Array.isArray(titles) ? titles : [])
    .map(title => String(title || '').trim())
    .filter(Boolean)
  if (cleaned.length < 2) {
    return null
  }
  let prefix = cleaned[0]
  for (const title of cleaned.slice(1)) {
    let index = 0
    const max = Math.min(prefix.length, title.length)
    while (
      index < max &&
      prefix[index].toLowerCase() === title[index].toLowerCase()
    ) {
      index += 1
    }
    prefix = prefix.slice(0, index)
  }
  prefix = trimHarbourTitlePrefixToToken(prefix, cleaned)
  if (!isHarbourBrandTitlePrefix(prefix)) {
    return null
  }
  return prefix
}

/** Group-level worst stack gap. Does not fetch estate venues. */
export function formatHarbourSisterGroupNudge(group = {}) {
  const { siteCount, gapKey, groupName } = group || {}
  const n = Math.max(0, Math.floor(Number(siteCount) || 0))
  if (n < 2) {
    return null
  }
  const gap = HARBOUR_SISTER_GROUP_GAP_LABEL[gapKey]
  if (!gap) {
    return null
  }
  const brand = String(groupName || '').trim()
  const who = brand ? `${n} ${brand} sites` : `${n} sister sites`
  return `${who} — none on ${gap}`
}
